export const typeInput = {
  textinput: { dataType: "text", type: "text", htmlType: "input" },
  urlinput: { dataType: "url", type: "url", htmlType: "input" },
  emailinput: { dataType: "email", type: "email", htmlType: "input" },
  numberinput: { dataType: "number", type: "number", htmlType: "input" },
  dateinput: { dataType: "datepick", type: "date", htmlType: "dateInput" },
  textarea: { dataType: "textarea", type: null, htmlType: "textarea" },
  multiplecheckboxes: {
    dataType: "checkboxlist",
    type: null,
    htmlType: "checkbox",
  },
  multipleradios: { dataType: "radiolist", type: null, htmlType: "radio" },
  selectbasic: { dataType: "selectlist", type: null, htmlType: "select" },
  textstatic: { dataType: "text", type: null, htmlType: "text-static" },
  titlestatic: { dataType: "text", type: null, htmlType: "title-static" },
  speratorstatic: { dataType: "text", type: null, htmlType: "sperator-static" },
  recipientDropdown: {
    type: "recipientDropdown",
    dataType: "recipientDropdown",
    htmlType: "recipientDropdown",
  },
  "recipient-dropdown": {
    dataType: "recipientlist",
    type: null,
    htmlType: "recipientDropdown",
  },
};
export const exampleFormJson = {
  EmbedForm: {
    Embed_Dynamic_Id: 8007989253,
    Embed_Dynamic_User_Id: 5301317,
    Embed_Dynamic_Culture: "en-US",
    Embed_Dynamic_Inner_Title: "test limit mails",
    Embed_Dynamic_Display_Title: "test limit mails",
    Embed_Dynamic_Url: "",
    Embed_Dynamic_JM_Logo: null,
    Embed_Dynamic_Body:
      '{"items":[{"template":"textinput","fields":{"label":"Name","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"emailinput","fields":{"label":"Email","helptext":"","required":true,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"textinput","fields":{"label":"Subject","helptext":"","required":false,"readonly":true,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"textinput","fields":{"label":"Text","helptext":"sdf","required":true,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"textarea","fields":{"label":"Comments","textarea":"","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false}},{"template":"numberinput","fields":{"label":"Number","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false}},{"template":"multiplecheckboxes","fields":{"label":"Multiple Checkboxes","checkboxes":["Option one","Option two"],"helptext":"check check","required":true,"readonly":false,"tempsave":false,"display":false,"downloadname":false}},{"template":"multipleradios","fields":{"label":"Multiple Radios","radios":["Option one","Option two"],"helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false}},{"template":"selectbasic","fields":{"options":["Option one","Option two"],"label":"Select Basic","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false}},{"template":"dateinput","fields":{"label":"Date","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}}],"formwidth":500,"formheight":753}',
    Embed_Dynamic_Width: 460,
    Embed_Dynamic_Height: 882,
    Embed_Dynamic_Size_Id: 1,
    Embed_Dynamic_Upload_Files_limit: 0,
    Embed_Dynamic_Recipients: "aviel@jumbomail.me",
    Embed_Dynamic_Send_Lead: false,
    Embed_Dynamic_Send_Download: false,
    Embed_Dynamic_Send_Copy: false,
    Embed_Dynamic_Manually_Delete: false,
    Embed_Dynamic_Delete_Days: 7,
    Embed_Dynamic_Progress_Status: 3,
    Embed_Dynamic_Creation_Domain: "",
    Embed_Dynamic_Mails_Sent_Count: 20,
    Embed_Dynamic_Creation_Date: "2022-03-03T09:00:50.4996734+02:00",
    Embed_Dynamic_Last_Update: "2022-04-05T17:04:48.1407653+03:00",
    Embed_Dynamic_Remove_Date: null,
    Embed_Dynamic_Active: true,
    Embed_Dynamic_End_Download_Link: true,
    Embed_Dynamic_Password: null,
    Embed_Dynamic_SetPassword: false,
    Embed_Dynamic_Allow_Access: false,
    Embed_Dynamic_End_Redirect: false,
    Embed_Dynamic_End_Redirect_Url: "",
    Embed_Dynamic_Display_Footer_Links: true,
    Embed_Dynamic_Custom_Footer_Links: false,
    Embed_Dynamic_End_Send_Button: true,
    Embed_Dynamic_Creation_Culture: "en",
    Embed_Dynamic_Buttons_Color_Code: "2ba1dc",
    Embed_Dynamic_Background_Color_Code: "#eceff1",
    Embed_Dynamic_Formats: "",
    Embed_Dynamic_Formats_Action: null,
    UserEmbedPageUrl: null,
  },
  EmbedFooterLinksList: {
    EmbedFormId: 4764258662,
    EmbedFooterLinksList: [
      {
        FooterId: 333,
        FooterTitle: "About",
        FooterUrl: "https://www.jumbomail.me:3000/en/jumbo-forms",
        FooterDisplayOrder: 1,
        FooterCreationDate: "2021-12-09T09:29:38.5692606+02:00",
      },
      {
        FooterId: 334,
        FooterTitle: "Support",
        FooterUrl: "https://www.jumbomail.me:3000/en/support/jumbo-embed",
        FooterDisplayOrder: 2,
        FooterCreationDate: "2021-12-09T09:29:38.6110966+02:00",
      },
      {
        FooterId: 335,
        FooterTitle: "Terms",
        FooterUrl: "https://www.jumbomail.me:3000/en/terms",
        FooterDisplayOrder: 3,
        FooterCreationDate: "2021-12-09T09:29:38.6402193+02:00",
      },
    ],
  },
};

export const exampleFieldsJson =
  '{"items":[{"template":"textinput","fields":{"label":"default-name","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"emailinput","fields":{"label":"default-email","helptext":"","required":true,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"textinput","fields":{"label":"default-subject","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false,"includeinemailsubject":false}},{"template":"textarea","fields":{"label":"default-comment","textarea":"","helptext":"","required":false,"readonly":false,"tempsave":false,"display":false,"downloadname":false}}],"formwidth":500,"formheight":0}';
